import mixitup from 'mixitup';
import mixitupMultifilter from '../mixitup-multifilter.min.js';


const AllWines = {
	init: function() {
		// console.log('AllWines specific code');
		mixitup.use(mixitupMultifilter, { multifilter: { enable: true } });

		//  Get the search value from the URL
		var hashedValue = window.location.search;

		if (hashedValue.replace('?', '') == '') {
			hashedValue = 'all';            //  Use the default filter if there's no hash value
			//  hashedValue = hashedValue.replace('#', '');

		} else {
			$('.wine-collections .wine-list').removeClass('stagger-wrap');

			//wine gift 
			if (hashedValue.includes("f-3-bottles", "f-4-bottles", "f-6-bottles")){
				hashedValue = hashedValue.replace(/[_]/g, '.') ; 
				hashedValue = hashedValue.replace('.f-4-bottles.f-6-bottles', ', .f-4-bottles, .f-6-bottles') ; 
				hashedValue = hashedValue.replace('?', '') ;      

				var beforeGift= hashedValue.substr(0, hashedValue.indexOf('.f-3-bottles'));
				var addBeforeToGifts =  ', ' + beforeGift + '.f-4-bottles, ' + beforeGift + '.f-6-bottles';
				
				hashedValue = hashedValue.replace(', .f-4-bottles, .f-6-bottles', addBeforeToGifts) ; 

			} else {
				hashedValue = hashedValue.replace(/[_]/g, '.') ; 
				hashedValue = hashedValue.replace('?', '') ;      
			}
		}

		let mixer = mixitup('.wine-list', {
			multifilter: { enable: true },
			callbacks: {
				onMixEnd: function(state) {
					if (state.hasFailed) {
						$('.wine-list-empty').css('display', 'flex');
					} else {
						$('.wine-list-empty').css('display', 'none');
					}
				},
				// onMixClick: function(state, originalEvent) {
				// 	console.log(state.activeFilter.selector); // 'all'
			   	// }
			},
			load: {
				filter: hashedValue
				//filter: '.f-2021, .f-6-bottles'
			}
		});

		//console.log('hashed: ' + hashedValue)

		$('#filters-reset').on('click', function () {
			mixer.filter('all');
			$('.nav-item').each(function() {
				const title = $(this).find('h2');
				const defaultText = title.data('default');
				title.html(defaultText);
				title.removeClass('active');
			});
			$('fieldset li button').removeClass('mixitup-control-active');

			var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '' ;

			window.history.pushState({path:newurl},'',newurl);
		});

		$('.nav-dropdowns-wrapper fieldset li button').on('click', function() {
			$('.nav-item').removeClass('active');
			$('.nav-dropdown').removeClass('active');
		});

		$('.nav-item').on('click', function() {
			$('.nav-dropdown').removeClass('active');
			const identifier = $(this).data('identifier');
			const position = $(this).position();
			const minWidth = $(this).width();
			const isActive = $(this).hasClass('active');
			$('.nav-item').removeClass('active');
			if (isActive) {
				$('.nav-dropdown').removeClass('active');
				return;
			} else {
				$(this).addClass('active');
			}
			const selectedDropdown = $(`.nav-dropdown-${identifier}`);
			selectedDropdown.addClass('active');
			selectedDropdown.css('left', position.left);
			selectedDropdown.css('min-width', minWidth + 20);
		});



		$('.nav-dropdowns-wrapper fieldset li button').on('click', function() {
			$('.wine-collections .wine-list').removeClass('stagger-wrap');

			const fieldset = $(this).closest('fieldset');
			const identifier = fieldset.data('identifier');
			const navItem = $(`.nav-item[data-identifier='${identifier}']`);
			const title = navItem.find('h2');
			const text = $(this).text();
			if (text == 'All' && !navItem.hasClass('gift-filter')) {
				const defaultText = title.data('default');
				title.html(defaultText);
				title.removeClass('active');
			} else {
				title.html(text);
				title.addClass('active');
			}

			setTimeout(changeURL, 1000);

		});

		function changeURL() {

			const filter = [];

			var active = document.querySelectorAll('.mixitup-control-active');
			document.querySelectorAll('.mixitup-control-active').forEach(elem => filter.push(elem.getAttribute('data-filter')));

			var filterString = filter.toString().replace(/[,]/g,'');
			var noSpace = filterString.replace(/[ ]/g,'');
			//console.log(noSpace)


			if (history.pushState) {
				var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + noSpace.replace(/[.]/g, '_') ;

				window.history.pushState({path:newurl},'',newurl);
			}

		}

		let wineList = $('.wine-list');

		$('.nav-dropdown').each(function(){

			let target = $(this)
			if(target.hasClass('sort')) return;

			target.find('button').each(function(){
				let btn = $(this)
				if(btn.hasClass('all')) return;

				let filterClass = btn.data('filter')

				if(wineList.find(filterClass).length === 0 ){
					btn.parent('li').remove();
				}

			})

		})



	}
}

export default AllWines